import {damsFetch} from "../app/damsFetch";
import decamelizeKeysDeep from "decamelize-keys-deep";
import {clientLog} from "../clientLog";
import {useDocumentTranslation} from "../documents/documentContext";
import {useSnackbar} from "notistack";

export const useAddSubject = () => {
    const t = useDocumentTranslation();
    const {enqueueSnackbar} = useSnackbar();

    const callback = json => {
        const {collectionId, id, uniqueId, locale, content, source, sourceId} = json;
        const {name} = content;


        return Promise.resolve({
            referenceType: "subject",
            _action: "put",
            collectionId: collectionId,
            reference: {
                id: id,
                uniqueId: uniqueId,
                locale: locale,
                _action: "put",
                title: name,
                status: "published",
                source: source,
                sourceId: sourceId,
                content: {
                    name: name,
                },
            },
        });
    };

    const errorCallback = error => {
        clientLog('error', error, 'useAddSubject');
        enqueueSnackbar(t("saveSubjectFailTitle", "Feil ved lagring av emneord"), {variant: 'error'});
        return Promise.reject(error);
    };

    const createMappedSubjectObject = s => {
        const {collectionId, source, sourceId} = s;
        const title = s.content?.name || s.title;
        return {
            collectionId: collectionId,
            schemaId: 1,
            locale: "no",
            _action: "put",
            title: title,
            status: "published",
            source: source,
            sourceId: sourceId,
            documentType: "subject",
            content: {
                name: title,
            }
        };
    };

    return ({subjects}) => {
        return Promise.all(
            subjects.map((subject) => {
                const newSubject = createMappedSubjectObject(subject);
                return damsFetch(`/documents`, {
                    method: "POST",
                    body: JSON.stringify(decamelizeKeysDeep(newSubject)),
                })
                    .then(callback)
                    .catch(errorCallback);
            })
        );
    };
};
